import { useEffect, useState } from "react"
import { Button, Form, Modal, Table } from 'react-bootstrap';
import SimpleBar from "simplebar-react";
import Textbox from "../../form/textbox";
import enums from "../../../utilities/enums";
import stringUtilities from "../../../utilities/stringUtilities";
import arrayUtilities from "../../../utilities/arrayUtilities";
import ConfigurationDialog from "../../map/drawingTools/_configurationDialog";
import { ReorderingWrapper } from "../reorderingWrapper";
import { ReorderingRowWrapper } from "../reorderingRowWrapper";
import { arrayMove } from "@dnd-kit/sortable";
import { DragHandlerIcon } from "../dragHandlerIcon";
import { DragOverlay } from "@dnd-kit/core";
import { ConfigFormRowDragOverlay } from "../configFormRowDragOverlay";

export const WorkflowConfigFieldsForm = ({ onSubmitFields, showFieldsForm, setShowFieldsForm, editModeData, workflowHasData, onCancel }) => {

    const [workflowConfigFieldsName, setWorkflowConfigFieldsName] = useState(null)
    const [workflowConfigFieldsType, setWorkflowConfigFieldsType] = useState("Text")
    const [workflowConfigFieldsAllowOther, setWorkflowConfigFieldsAllowOther] = useState(false)
    const [workflowConfigFieldsValues, setWorkflowConfigFieldsValues] = useState([])
    const [workflowConfigFieldsDefaultValue, setWorkflowConfigFieldsDefaultValue] = useState(null)
    const [workflowConfigFieldsValue, setWorkflowConfigFieldsValue] = useState(null)
    const [canSave, setCanSave] = useState(false)
    const [showValueModal, setShowValueModal] = useState(false)
    const [editableIndex, setEditableIndex] = useState(null)
    const [deleteIndex, setDeleteIndex] = useState(null)
    const [activeItem, setActiveItem] = useState(null)
    const resetFields = () => {
        setWorkflowConfigFieldsName(null)
        setWorkflowConfigFieldsType("Text")
        setWorkflowConfigFieldsAllowOther(false)
        setWorkflowConfigFieldsValues([])
        setWorkflowConfigFieldsDefaultValue(null)
        setShowFieldsForm(false)
    }

    const handleFieldsSubmit = () => { 
        const payloadObject = {
            name: workflowConfigFieldsName,
            type: workflowConfigFieldsType,
            allowOther: workflowConfigFieldsAllowOther,
            values: workflowConfigFieldsValues,
            defaultValue: workflowConfigFieldsDefaultValue,
        }

        onSubmitFields(payloadObject)
        resetFields()
    }

    useEffect(() => {
        if (editModeData) {
            setWorkflowConfigFieldsName(editModeData.hasOwnProperty("name") ? editModeData.name : null)
            setWorkflowConfigFieldsType(editModeData.hasOwnProperty("type") && !stringUtilities.isNullOrEmpty(editModeData.type) ? editModeData.type : "Text")
            setWorkflowConfigFieldsAllowOther(editModeData.hasOwnProperty("allowOther") && editModeData.allowOther !== undefined ? editModeData.allowOther : false)
            if (editModeData.hasOwnProperty("values") && !arrayUtilities.isNullOrEmpty(editModeData.values)) {
                setWorkflowConfigFieldsValues(editModeData.values)
            }
            setWorkflowConfigFieldsDefaultValue(editModeData.hasOwnProperty("defaultValue") ? editModeData.defaultValue : null)
        }
    }, [editModeData])

    useEffect(() => setCanSave(!stringUtilities.isNullOrEmpty(workflowConfigFieldsName)), [workflowConfigFieldsName])

    const addValue = () => {
        setWorkflowConfigFieldsValues(prevState => [...prevState, workflowConfigFieldsValue])
        setWorkflowConfigFieldsValue("")
        setShowValueModal(false)
    }

    const editValue = (index) => {
        const newValuesSortingArray = workflowConfigFieldsValues.toSpliced(index, 1, workflowConfigFieldsValue)
        setWorkflowConfigFieldsValues(newValuesSortingArray)
        setWorkflowConfigFieldsValue("")
        setShowValueModal(false)
        setEditableIndex(null)
    }

    const deleteValue = (index) => {
        const newValuesSortingArray = workflowConfigFieldsValues.toSpliced(index, 1)
        setWorkflowConfigFieldsValues(newValuesSortingArray)
        setDeleteIndex(null)
    }

    return (
        <ConfigurationDialog preventSave={!canSave} show={showFieldsForm} title={`${editModeData ? "Edit" : "Add"} Fields`} onSave={() => handleFieldsSubmit()} onCancel={() => {
            setShowFieldsForm(false)
            resetFields()
            onCancel()
        }}>
            <div className="d-flex flex-column">
            <Form.Group className='row mb-3'>
                <Form.Label className='form-label fs-sm col-form-label'>Name</Form.Label>
                <div>
                    <Form.Control size='sm' value={ workflowConfigFieldsName } type="text" onChange={ (e) => setWorkflowConfigFieldsName(e.target.value) } />
                        {
                            workflowHasData && editModeData && 
                            workflowConfigFieldsName !== editModeData.name && 
                            <>
                                <small className="text-danger"><i className="fi-alert-circle"></i> This workflow has data attached to it. Editing the field name could lead to loss of data. Please proceed with caution. </small> 
                                <Button onClick={() => setWorkflowConfigFieldsName(editModeData.hasOwnProperty("name") ? editModeData.name : null)} variant="secondary" size="xs">
                                    <span className="d-flex align-items-center"><i className="fi-rotate-left me-2"></i> Reset</span>
                                </Button>
                            </>
                        }
                </div>
            </Form.Group>
            <Form.Group className='row mb-3'>
                <Form.Label className='form-label fs-sm col-form-label'>Type</Form.Label>
                <div className="d-flex align-items-center">
                    <Form.Select 
                        size='sm' 
                        value={ workflowConfigFieldsType } 
                        onChange={ (e) => {
                            setWorkflowConfigFieldsType(e.target.value)
                        } }>
                        { Object.entries(enums.WorkflowConfigFieldTypes).map(([key, value]) => <option key={ key } value={ key }>{ value }</option>) }
                    </Form.Select>
                </div>
            </Form.Group>
            {
                workflowConfigFieldsType === "DropDownList" &&
                <Form.Group className='mb-3 row'>
                    <Form.Label className='form-label fs-sm col-form-label' htmlFor="workflow-config-fields-allow-other">
                        Allow Other
                    </Form.Label>
                    <div className="col-md-9 d-flex align-items-center">
                        <Form.Check type='switch' id="workflow-config-fields-allow-other" checked={ workflowConfigFieldsAllowOther } onChange={ (e) => setWorkflowConfigFieldsAllowOther(e.target.checked) } />
                    </div>
                </Form.Group>
            }
            {
                (workflowConfigFieldsType === "DropDownList" || workflowConfigFieldsType === "Radio") &&
                    <Form.Group className='mb-3'>
                        <Form.Label className='form-label fs-sm col-form-label d-flex align-items-center justify-content-between'>
                            Values <Button onClick={ () => setShowValueModal(true) } size="xs" variant="secondary" className='ms-2'><i className='fi-plus me-2'></i>Add</Button>
                        </Form.Label>
                        {
                            !arrayUtilities.isNullOrEmpty(workflowConfigFieldsValues) &&
                            <ReorderingWrapper handleDragEndTable={ event => {
                                const { active, over } = event
                                if (active.id !== over.id) {
                                    const reOrderedArray = arrayMove(workflowConfigFieldsValues, event.active.id, event.over.id)
                                    setWorkflowConfigFieldsValues(reOrderedArray)
                                    setActiveItem(null)
                                }
                            } } sortingArray={ workflowConfigFieldsValues }
                            handleDragStart={event => {
                                const { active } = event
                                setActiveItem(workflowConfigFieldsValues.find((_, index) => index === Number(active.id)))
                            }}
                            >
                                <Table hover className="workflow-config-table config-form-table">
                                    <tbody>
                                        {
                                            workflowConfigFieldsValues.map(
                                                (item, index) => <ReorderingRowWrapper key={ index } id={ index }>
                                                    <td className="pt-3"><DragHandlerIcon /></td>
                                                    <td>{ item }</td>
                                                    <td className="text-end">
                                                        <i onClick={ () => {
                                                            setShowValueModal(true)
                                                            setWorkflowConfigFieldsValue(item)
                                                            setEditableIndex(index)
                                                        } } role='button' className='fi-edit me-2'></i>
                                                        <i onClick={ () => setDeleteIndex(index) } role='button' className='fi-trash'></i>
                                                    </td>
                                                </ReorderingRowWrapper>
                                            )
                                        }
                                    </tbody>
                                </Table>
                                {
                                activeItem !== null  &&
                                    <DragOverlay>
                                        <ConfigFormRowDragOverlay item={activeItem} />
                                    </DragOverlay>
                                }
                            </ReorderingWrapper>
                        }
                    </Form.Group>
            }
            <Form.Group className='row mb-3'>
                <Form.Label className='form-label fs-sm col-form-label'>Default Value</Form.Label>
                <div>
                    <Form.Control size='sm' value={ workflowConfigFieldsDefaultValue } type="text" onChange={ (e) => setWorkflowConfigFieldsDefaultValue(e.target.value) } />
                </div>
            </Form.Group>
            <Modal show={ showValueModal } onHide={ () => {
                setWorkflowConfigFieldsValue("")
                setShowValueModal(false);
            } } centered>
                <Modal.Header>
                    <Modal.Title>Add value</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SimpleBar autoHide={ false } className='simplebar-no-autohide pe-3' style={ { maxHeight: 'calc(100vh - 380px)' } }>
                        <Textbox label="Name" value={ workflowConfigFieldsValue } onChange={ setWorkflowConfigFieldsValue } />
                    </SimpleBar>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='secondary' onClick={ () => {
                        setWorkflowConfigFieldsValue("")
                        setShowValueModal(false);
                    } }>Cancel</Button>
                    <Button disabled={ stringUtilities.isNullOrEmpty(workflowConfigFieldsValue) } size="sm" variant="primary" onClick={ () => {
                        if (editableIndex !== null) {
                            editValue(editableIndex)
                        } else addValue()
                    }}>Submit</Button>
                </Modal.Footer>
            </Modal>

            {
                deleteIndex !== null &&
                <Modal show onHide={ () => setDeleteIndex(null) } centered>
                    <Modal.Header>
                        <Modal.Title>Delete Value</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            workflowHasData 
                            ? <> This workflow has data attached to it. Deleting this entry could lead to loss of data. Please proceed with caution.</>
                            : <>Are you sure?</>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setDeleteIndex(null)}>Cancel</Button>
                        <Button size="sm" variant="danger" onClick={ () => deleteValue(deleteIndex) }>Delete</Button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
        </ConfigurationDialog>
    )
}